"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _TimezoneTypes = _interopRequireDefault(require("../constants/TimezoneTypes"));

var _RelativeDurationFormats = _interopRequireDefault(require("../constants/RelativeDurationFormats"));

var _formatRelativeDuration = _interopRequireDefault(require("../utils/formatRelativeDuration"));

var getRelativeDuration = function getRelativeDuration(from, to, options) {
  return (0, _formatRelativeDuration.default)(_I18n.default.moment.duration(Math.abs(to.diff(from))), options);
};

var _default = (0, _createReactClass.default)({
  displayName: "FormattedDuration",
  propTypes: {
    includeAffix: _propTypes.default.bool,
    type: _propTypes.default.oneOf([_TimezoneTypes.default.PORTAL, _TimezoneTypes.default.USER, _TimezoneTypes.default.UTC]),
    format: _propTypes.default.oneOf(Object.keys(_RelativeDurationFormats.default).map(function (format) {
      return _RelativeDurationFormats.default[format];
    })),
    from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.number, _propTypes.default.array]),
    to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.number, _propTypes.default.array]),
    toFromValidator: function toFromValidator(props, propName, componentName) {
      if (!props.from && !props.to) {
        console.warn(componentName + " should have either a \"to\" or a \"from\" prop", componentName);
      }
    },
    combined: _propTypes.default.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes.default.PORTAL,
      includeAffix: false,
      combined: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        includeAffix = _this$props.includeAffix,
        type = _this$props.type,
        from = _this$props.from,
        to = _this$props.to,
        format = _this$props.format,
        combined = _this$props.combined;

    var nowMoment = _I18n.default.moment[type]();

    var duration;

    if (!to && !from) {
      duration = '';
    } else if (!to) {
      var fromValue = _I18n.default.moment[type](from);

      duration = format ? getRelativeDuration(fromValue, nowMoment, {
        format: format,
        combined: combined
      }) : fromValue.toNow(!includeAffix);
    } else if (!from) {
      var toValue = _I18n.default.moment[type](to);

      duration = format ? getRelativeDuration(nowMoment, toValue, {
        format: format,
        combined: combined
      }) : toValue.fromNow(!includeAffix);
    } else {
      var _fromValue = _I18n.default.moment[type](from);

      var _toValue = _I18n.default.moment[type](to);

      duration = format ? getRelativeDuration(_fromValue, _toValue, {
        format: format,
        combined: combined
      }) : _toValue.from(_fromValue, !includeAffix);
    }

    return _react.default.createElement("span", null, duration);
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedDuration.js
// module id = 429
// module chunks = 209 210 211 212